const company = {
  name: "RAYYAN DENIM",
  tagline: "Denim, Crafted for Global Markets.",
  subTagline: "Premium Denim. Built for Corporate Markets.",
  secondaryTagline: "From Fabric to Finished Denim.",
  description: "RAYYAN DENIM is a denim export and distributorship partner for international buyers, importers, malls, multi-brand outlets (MBOs), retail chains, apparel brands, and distributors seeking dependable denim collections.",
  brandProfile: {
    overview: "Rayyan Denim is a leading homegrown international corporate denim and casual apparel brand founded in 2022 in Bhavnagar, Gujarat. Known for a bold, brash, and irreverent style, the brand creates fashion-forward clothing for the Indian youth market.",
    founded: "2022, Bhavnagar, Gujarat",
    leadership: "Rayyan Gadera",
    headquarters: "Bhavnagar, Gujarat",
    products: "Five-pocket jeans, fashionable denims, cargos, trousers, shorts, shirts, t-shirts, jackets, and sweatshirts.",
    presence: "Available across hundreds of cities in India.",
    distribution: "Distributed through exclusive brand outlets (EBOs), multi-brand outlets (MBOs), large-format stores, and online channels."
  },

  // Contact details — Real corporate info
  email: "info@rayyandenim.com",
  phone: "+91 93288 24942",
  whatsapp: "+919328824942",
  address: "Plot No. 8 - 9/d, Vishwakarma Industries, B/H, Chitra Gujarat Industrial Development Corporation, Bhavnagar, Gujarat 364004",

  // Social Links
  socials: {
    instagram: "https://instagram.com/rayyandenim_official",
    youtube: "https://youtube.com/@rayyandenim",
    facebook: "https://facebook.com/rayyandenim",
    linkedin: "https://linkedin.com/company/rayyan-denim"
  },

  // Target Audience profiles
  targetAudience: [
    {
      id: "international-buyers",
      title: "International Buyers",
      description: "Procurement teams sourcing commercially strong denim collections for malls, MBOs, retail chains, and regional store networks.",
      icon: "Globe"
    },
    {
      id: "importers",
      title: "Importers & Overseas Buyers",
      description: "Apparel import houses seeking reliable production cycles, export packaging, and consistent stock for their retail customers.",
      icon: "Ship"
    },
    {
      id: "global-distributors",
      title: "Global Apparel Distributors",
      description: "International distributors requiring high-volume capacity, container logistics, and repeatable stock across multiple outlets.",
      icon: "Boxes"
    },
    {
      id: "retail-chains",
      title: "Malls, MBOs & Retail Chains",
      description: "Multi-brand outlets, malls, and store groups needing dependable fits, colours, replenishment, and export-ready assortments.",
      icon: "Store"
    },
    {
      id: "apparel-brands",
      title: "Apparel Brands",
      description: "Fashion labels seeking dependable denim collections, product development, and scalable export supply.",
      icon: "Tag"
    }
  ],

  // Core Pillars
  pillars: [
    {
      title: "QUALITY",
      subtitle: "Uncompromising Precision",
      description: "Every fabric roll and finished seam undergoes rigorous multi-point visual and structural checks."
    },
    {
      title: "CRAFTSMANSHIP",
      subtitle: "Mastery in Every Thread",
      description: "Combining traditional indigo dyeing aesthetics with state-of-the-art washing and laser finishing."
    },
    {
      title: "CONSISTENCY",
      subtitle: "Dependable Production",
      description: "Rigid standard operating procedures ensure every batch meets specs from sample approval to export loading."
    },
    {
      title: "GLOBAL OUTLOOK",
      subtitle: "Tailored for International Trade",
      description: "Structured communication, transparent workflows, and international corporate standards."
    }
  ]
};

export default company;
